import {useAuth} from "../../providers/authprovider";
import React, {useEffect, useState} from "react";
import { Button, Col, Form, Row} from "react-bootstrap";
import AddressForm from "../../components/AddressForm";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import {PersonTable} from "../../components/PersonForm";
import {
     useNavigate
} from "react-router-dom";
import Loading from "../../components/LoadingInfo";
import ResponseAlert from "../../components/ResponseAlert";
const CONTEXT = 'clients';

export default function AddEditClientForm(props){
    const navigate = useNavigate();
    const auth = useAuth();
    const [rajcompanies, setRajcompanies] = useState(undefined)
    const [validated, setValidated] = useState(false);
    const [disabled] = useState(false);
    const [alert, setAlert] = useState({
        show:false,
        content: "",
    });
    const CLIENT_EDITION = props.client !== undefined

    const [clientData, setClientData] = React.useState(()=>{
        if(props.client === undefined)
            return {id:undefined, name: '', nip: '', description:'', rajcompany_id:'', address:{}, persons:[] }


        return {...props.client, rajcompany_id: props.client.rajcompany.id}
    });

    const handleChange = e => setClientData({ ...clientData, [e.target.name]: e.target.value });

    useEffect(()=>{
        if(rajcompanies !== undefined  )
            return;

        auth.rajcompanies.get(CONTEXT, (result)=>{
            if(result.success){
                setClientData(prev=>{
                    return {...prev, rajcompany_id: result.content[0].id}
                })
                return setRajcompanies(result.content)
            }


            setRajcompanies([])
            setAlert({show:true,content:result.error});
        })
    })


    let onChangeAddresState = (data)=>{
        setClientData({...clientData, address:data.address});
    }

    let handleSaveClient = (event)=>{

        event.preventDefault();
        event.stopPropagation();

        if(disabled)
            return;

        const form = event.currentTarget;
        if (form.checkValidity() === true) {
            const formData = {...clientData};


            auth.clients.add(formData, (response)=>{
                const {success, error, content} = response;
                if(success && props.onHide){
                    props.onHide(response)
                    if(!CLIENT_EDITION)
                        navigate("/buildings/create?clientId="+content.id, {replace: true})
                } else {
                    setAlert({show:true, content:error});
                }
            }, CLIENT_EDITION)
        }

        setValidated(true);
    }

    let handlePersonChange = (persons)=>{
        setClientData({...clientData, persons:persons});
    }

    let handleCancel = ()=>{
        if(props.onHide)
            props.onHide();
    }


    return (
            <div className={"container "}>
                <ResponseAlert show={alert.show} error={alert.content} />
                {
                    rajcompanies !== undefined  ?
                        <Form disabled noValidate validated={validated} action={"post"} onSubmit={handleSaveClient} >
                            <h3 className={"text-center"}>Dodaj kontrahenta</h3>
                            <Row >

                                <h5>Podstawowe dane</h5>
                                <Col lg={4}>
                                    <Form.Group className="mb-3" controlId="clientName">
                                        <Form.Label>Nazwa</Form.Label>
                                        <Form.Control required type="text" name={"name"} placeholder="Nazwa kontrahenta" onChange={handleChange} defaultValue={clientData.name} />
                                    </Form.Group>
                                </Col>
                                <Col lg={4} >
                                    <Form.Group className="mb-3" controlId="clientNip">
                                        <Form.Label>NIP</Form.Label>
                                        <Form.Control required type="text" name={"nip"} placeholder="NIP" onChange={handleChange}  defaultValue={clientData.nip} />
                                    </Form.Group>
                                </Col>

                                <Col lg={4} >
                                    <Form.Group className="mb-3" controlId="clientDescription">
                                        <Form.Label>Spółka obsługująca</Form.Label>
                                        <Form.Select required={true} onChange={handleChange} name={"rajcompany_id"} defaultValue={clientData.rajcompany_id} aria-label="Default select example" >
                                            {
                                                rajcompanies && rajcompanies.map((rajcompany)=>
                                                    <option key={rajcompany.id} value={rajcompany.id} >{rajcompany.full_name}</option>
                                                )
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <AddressForm default={clientData.address} onChange={onChangeAddresState} />
                                <Col lg={12} >
                                    <Form.Group className="mb-3" controlId="clientDescription">
                                        <Form.Label>Dodatkowy opis</Form.Label>
                                        <Form.Control as="textarea" rows={3} name={"description"} placeholder="opis" onChange={handleChange}  defaultValue={clientData.description} />
                                    </Form.Group>
                                </Col>
                                <Col lg={12}>
                                    <Row>
                                        <div className={"border bg-light fs-5"}>
                                            Osoby do kontaktu
                                        </div>

                                        <PersonTable persons={clientData.persons} onChange={handlePersonChange} />
                                    </Row>
                                </Col>
                                <div className={"text-center pt-4"}>
                                    <Button variant={"secondary"}  className={"w-20 me-4"}  type={"button"} onClick={handleCancel}>
                                        Anuluj
                                    </Button>
                                    <Button disabled={disabled} className={"w-50"}  type={"submit"} name={"save"}>
                                        {disabled ? <FontAwesomeIcon icon={faSpinner}  spin/> : "Zapisz" }
                                    </Button>
                                </div>
                            </Row>
                        </Form>
                        :
                        <Loading />
                }
            </div>
    );

}